import PropTypes from 'prop-types'
import React from 'react'
import { WideLayout } from 'layouts'
import Drawer from 'components/Drawer'
import { useFaqNavItems } from 'modules/Faq/hooks/useFaqNavItems'
import styles from 'modules/Faq/styles/Faq.module.scss'

const FaqWideLayout = ({ children = null, ...rest }) => {
  const { items, loading } = useFaqNavItems(true)

  return (
    <WideLayout
      {...rest}
      className={styles['faq-wide-layout']}
      hasCloseButton={false}
      hasToggler={true}
    >
      <Drawer
        isDetached
        navItems={items}
        navLoading={loading}
        hasBalance={false}
      >
        {children}
      </Drawer>
    </WideLayout>
  )
}

FaqWideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FaqWideLayout
